(function($) {
    $.fn.tableAccessibility = function() {
        this.each(function() {
            var $table = $(this);

            function showOrHideTableSwipeInfo() {
                var $tableContainer = $table.parent('.table-responsive'),
                    $tableSwipeInfo = $tableContainer.find('.table-swipe-info'),
                    tableWidth      = $table.width(),
                    viewportWidth   = $('body').innerWidth();

                function showTableSwipeInfo() {
                    if ($tableSwipeInfo.length === 0) {
                        $tableContainer.prepend(`
                            <div class="table-swipe-info">
                                <i class="fa-sharp fa-light fa-hand-point-up"></i>
                            </div>`
                        );
                    }
                    $tableSwipeInfo = $tableContainer.find('.table-swipe-info');
                    $tableSwipeInfo.show();
                    $table.css('margin-top', '3rem');
                }

                function hideTableSwipeInfo() {
                    $tableSwipeInfo.hide();
                    $table.css('margin-top', 'auto');
                }

                // console.log($table);
                if (tableWidth > viewportWidth) {
                    // console.log(`tableWidth (${tableWidth}) > viewportWidth (${viewportWidth})`);
                    showTableSwipeInfo();
                } else {
                    // console.log(`tableWidth (${tableWidth}) < viewportWidth (${viewportWidth})`);
                    hideTableSwipeInfo();
                }
            }

            $table.wrap('<div class="table-responsive"></div>');

            showOrHideTableSwipeInfo($table);

            $(window).on('resize', ($.debounce(function() {
                showOrHideTableSwipeInfo();
            }, 250)));

            const observer = new IntersectionObserver(showOrHideTableSwipeInfo, {
                root: document.querySelector('body'),
                rootMargin: '0px',
                threshold: 0.1
            });
            observer.observe($table[0]);
        });

        return this;
    };
}(jQuery));
